const SERVICES = [
  {
    num: "SERVICE 01",
    title: "Clonage & Remplacement",
    desc: "Copie intégrale 1:1 des données Flash et EEPROM sur un calculateur donneur pour un remplacement plug-and-play sans re-codage concessionnaire.",
    meta: "DÉLAI 24/48H",
    price: "DÈS 149 €",
    stagger: "card-stagger-1",
  },
  {
    num: "SERVICE 02",
    title: "Dépollution & Stage 1",
    desc: "Optimisation puissance et couple, neutralisation logicielle des anomalies FAP, vanne EGR et système AdBlue défaillants.",
    meta: "PROGRAMME SUR MESURE",
    price: "DÈS 199 €",
    stagger: "card-stagger-2",
  },
  {
    num: "SERVICE 03",
    title: "Anti-Démarrage & Diagnostic",
    desc: "Suppression anti-démarrage (Immo Off), réparation des étages d'allumage/injection et diagnostic approfondi des pannes internes.",
    meta: "RAPPORT TEST INCLUS",
    price: "DÈS 120 €",
    stagger: "card-stagger-3",
  },
  {
    num: "SERVICE 04",
    title: "Clonage & Réparation TCU",
    desc: "Clonage et réparation des calculateurs de boîte de vitesses automatique (TCU / mécatronique DSG, EDC, ZF...) : copie à l'identique sur boîtier donneur ou réparation des pannes internes.",
    meta: "DÉLAI 24/48H",
    price: "SUR DEVIS",
    stagger: "card-stagger-4",
  },
  {
    num: "SERVICE 05",
    title: "Calculateur Airbag",
    desc: "Effacement des données crash (crash data), réparation et clonage de calculateurs airbag après un choc ou un défaut — votre voyant airbag s'éteint enfin.",
    meta: "TEST BANC INCLUS",
    price: "SUR DEVIS",
    stagger: "card-stagger-1",
  },
  {
    num: "SERVICE 06",
    title: "Compteurs",
    desc: "Réparation de compteurs : affichage défaillant, pixels manquants, aiguilles mortes, éclairage HS — et clonage à l'identique sur bloc donneur.",
    meta: "DÉLAI 24/48H",
    price: "SUR DEVIS",
    stagger: "card-stagger-2",
  },
];

export const Services = () => (
  <section id="services" className="py-24 md:py-32 px-6 border-b border-[#1C2C4E]">
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.14em] text-[#51ADDA] mb-2">Interventions Électroniques</p>
          <h2 className="font-display text-4xl md:text-5xl uppercase tracking-tight text-white">Prestations sur Mesure</h2>
        </div>
        <p className="text-slate-400 max-w-md text-sm">
          Particuliers et garages professionnels : nos ingénieurs traitent toutes marques de calculateurs (Bosch, Delphi, Siemens, Magneti Marelli).
        </p>
      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        {SERVICES.map((s) => (
          <div key={s.num} data-testid={`service-card-${s.num.split(" ")[1]}`} className={`${s.stagger} p-8 rounded-lg bg-[#0F1D36] border border-[#1C2C4E] flex flex-col justify-between`}>
            <div>
              <span className="font-mono text-xs text-[#51ADDA] block mb-4">{s.num}</span>
              <h3 className="font-display text-2xl uppercase text-white mb-3">{s.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed mb-6">{s.desc}</p>
            </div>
            <div className="pt-4 border-t border-[#1C2C4E] flex justify-between items-center text-xs font-mono text-slate-300">
              <span>{s.meta}</span>
              <span className="text-[#51ADDA]">{s.price}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
